import shots from "./featureShots.json";

/**
 * Where a „Co umíme" still lives, and how big it is (KAN-1950).
 *
 * ``featureShots.json`` is written by ``scripts/feature_shots.py`` next
 * to the WebP files it produces, so ``width``/``height`` on the
 * ``<img>`` come from the file itself and cannot drift from it by hand.
 * Both languages are cut from the same clip, so one size serves both.
 * The third number is the width the screen had in the app, in CSS px:
 * a tablet-sized terminal screen is shown at that size rather than
 * stretched across the page column with its type doubled.
 */
const SIZES: Record<string, readonly number[] | undefined> = shots;

export interface FeatureShot {
  src: string;
  width: number;
  height: number;
  /** Width the screen had in the app, CSS px. */
  cssWidth: number;
}

export function featureShot(id: string, lang: string): FeatureShot | null {
  const size = SIZES[id];
  if (!size || size.length !== 3) return null;
  return {
    src: `/features/${lang}/${id}.webp`,
    width: size[0],
    height: size[1],
    cssWidth: size[2],
  };
}
